import axios from 'axios';
import { Api } from './Variables';

export default axios.create({
  baseURL: `${Api.Url}`
});